/**
 * Devuelve el rango de páginas visibles para un paginador con siblings.
 * Ejemplo: current=5, total=10, siblings=1 → [1, '...', 4, 5, 6, '...', 10]
 * Si `total <= 5`, devuelve todas las páginas sin ellipsis.
 */
export function getPageRange(current: number, total: number, siblings = 1): (number | '...')[] {
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | '...')[] = [];
  const left = Math.max(2, current - siblings);
  const right = Math.min(total - 1, current + siblings);
  pages.push(1);
  if (left > 2) pages.push('...');
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}
